import React, {useCallback, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import {clientSideUpload} from "../../helpers/FIleHelper";

const SingleFileUploader = (props) => {
    const {
        name,
        value       = null,
        placeholder = "",
        uploadLabel = "Upload",
        required    = true,
        error       = null,
        disabled    = false,
        accepts     = '*',
        onChange    = (value) => {},
    } = props;

    const onDrop = useCallback(async (acceptedFiles) => {
        const file = await clientSideUpload(acceptedFiles[0]);

        onChange(file);
    }, [value, onChange])

    const {isDragActive, getRootProps, getInputProps} = useDropzone({
        onDrop,
        maxFiles:   1,
        multiple:   false,
        accept:     accepts,
        disabled:   disabled
    });

    const handleClear = (event) => {
        event.preventDefault();
        event.stopPropagation();

        onChange(null);
    }

    return (
        <div className={"single-file-uploader"}>
            <div {...getRootProps({className: isDragActive ? 'dropzone active' : 'dropzone'})}>
                <input {...getInputProps()} />
                <div className={disabled ? "display-container form-control disabled" : "display-container form-control"}>
                    <div className="input-label">
                        {!!value && !!value.name ? value.name : placeholder}
                    </div>
                    <div className={"controls"}>
                        <div className={"btn btn-eh-lilac px-3 input-button"}>
                            {uploadLabel}
                        </div>
                        {!!value && (
                            <button
                                className={"m-0 mt-2 mt-md-0 ml-md-2 py-0 btn font-weight-bold px-3 btn-outline-danger clear-button"}
                                disabled={disabled}
                                onClick={(event) => handleClear(event)}
                            >
                                <span>Clear</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SingleFileUploader;
